<div
  class="flex items-center gap-2 w-full rounded-[4px] border border-primary-70 bg-primary-99 px-3 py-2"
  role="status"
  data-testid="sync-all-banner">
  <mat-icon
    svgIcon="info-circle"
    class="icon-size [--icon-size:24px] [--icon-stroke-width:2] shrink-0 !overflow-visible !text-info [--mat-icon-color:var(--color-info)]"
    aria-hidden="true" />
  <p class="label-large-prominent text-info m-0 flex-1 min-w-0">
    <span>{{ "You've added new content, regenerate documents to include it." | translate }}</span>
    {{ ' ' }}
    <button
      type="button"
      class="bg-transparent border-0 p-0 underline label-large-prominent text-info cursor-pointer disabled:opacity-50 disabled:cursor-default"
      [disabled]="disabled"
      (click)="onSyncAll()"
      data-testid="sync-all-banner-action">
      {{ 'Sync all' | translate }}
    </button>
  </p>
</div>
